import script from "./MyPieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPieChart.vue?vue&type=script&setup=true&lang=js"

import "./MyPieChart.vue?vue&type=style&index=0&id=8ceb718c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ceb718c"]])

export default __exports__